
import { useEffect, useState, } from "react";
import api from '../../../../services/api';
import { InputBase, Button} from "@mui/material";
import HeaderSession from "../../../../utils/headerSession";
import ListaExpediente from "./listaExpediente";
import ExpedienteForm from "../../../../pages/expediente/expedienteForm";
import { useParams, useSearchParams } from "react-router-dom";
import CreateDocExpediente from "./createDocExpediente";


export default function EntradaExpediente() {
    const [entradas, setEntradas] = useState('')
    const [configLista, setConfigLista] = useState('')
    const [perPage, setPerPage] = useState(50)
    const [openForm, setOpenForm] = useState(false)
    const [filter, setFilter] = useState('')
    // const [status, setStatus] = useState('Análise')
    const { status } = useParams()
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [documento, setDocumento] = useState('');

    useEffect(() => {
        setEntradas('')
        api.get(`/expedientes?status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&tipoDocumentoId=${documento}&page=${page}&perPage=${perPage}`)
            .then(response => {
                setEntradas(response.data.expedientes);
                setFilter(response.data.expedientes);
                setConfigLista(response.data);
            }).catch(err => '')
    }, [page, perPage, status, openForm, dataInicio, dataFim, documento])


    const filtraentradas = (valor) => {
        setEntradas(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
    }

    return (
        <div>
            <HeaderSession title={`REGISTOS DE EXPEDIENTES / ${status?.toUpperCase()}`} />

            <div style={{ display: 'flex', marginBottom: 20, gap: 5 }}>

                {status === 'Análise' &&
                    <>
                        <Button
                            variant="contained"
                            style={{ background: '#85287e', marginRight: 20 }}
                            onClick={() => setOpenForm(!openForm)}
                        >
                            Novo Registo
                        </Button>
                        <CreateDocExpediente />
                    </>
                }

                {/* FORMULARIO PARA CRIAR EXPEDIENTE */}
                <ExpedienteForm open={openForm} setOpenForm={setOpenForm} />

                <InputBase
                    style={{ width: '70%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                    sx={{ ml: 1, flex: 1 }}
                    autoFocus
                    placeholder="Filtro"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { filtraentradas(e.target.value) }}
                />
            </div>

            <ListaExpediente
                expedientes={entradas}
                setPage={setPage}
                configLista={configLista}
                setPerPage={setPerPage}
                page={page}
                setDataInicio={setDataInicio}
                setDataFim={setDataFim}
                dataInicio={dataInicio}
                dataFim={dataFim}
                setDocumento={setDocumento}
                filtraentradas={filtraentradas}
            />
        </div>
    )
}
